import { Text } from '@/ui';

type Props = {
  children: React.ReactNode;
};

export const SectionLabel = ({ children }: Props) => (
  <Text
    color="ink.soft"
    fontSize="ah-status"
    fontWeight={700}
    letterSpacing="0.09em"
    mb={4}
    textTransform="uppercase"
  >
    {children}
  </Text>
);
